import { Form, Select, Spin } from 'antd';
import React, { Dispatch, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Action } from 'typesafe-actions';
import { ApplicationState } from '../../store';
import { selectTransportadoraParceiraRequest } from '../../store/ducks/transportadoras/actions';
import { ROLE } from '../../utils/roles';
import TextFilter from '../TextFilter';
import { Props } from './props';

const SelectTransportadoraParceira: React.FC<Props> = ({ localStorageActive = true }) => {
  const dispatch = useDispatch<Dispatch<Action>>();
  const inscricaoAtiva = useSelector((state: ApplicationState) => state.auth?.inscricaoAtiva);
  const perfil = useSelector((state: ApplicationState) => state.auth.user?.perfil);
  const { cddAtivo } = useSelector((state: ApplicationState) => state.auth);
  const transportadoras = useSelector((state: ApplicationState) => state.Transportadoras.data);
  const loading = useSelector((state: ApplicationState) => state.Transportadoras.loading);
  const inscricaoTransp = useSelector(
    (state: ApplicationState) => state.auth.user?.inscricoesEstaduais
  );
  const { Option } = Select;

  useEffect(() => {
    let controller = new AbortController();
    if (perfil !== ROLE.TRANSPORTADORA)
      dispatch(selectTransportadoraParceiraRequest(cddAtivo?.codCdd as number, inscricaoAtiva));
    else {
      const transpInsc = inscricaoTransp?.map((cod) => cod.codParceiro);
      dispatch(
        selectTransportadoraParceiraRequest(cddAtivo?.codCdd as number, transpInsc as number[])
      );
    }
    return () => {
      controller.abort();
    };
  }, [dispatch, cddAtivo, inscricaoAtiva, perfil, inscricaoTransp]);

  const onChange = (values: any) => {
    localStorageActive === true &&
      localStorage.setItem(`codTransportadora${window.location.pathname}`, values);
  };

  const children = [];
  children.push(
    transportadoras?.map((item: any) => (
      <Option key={item.codParceiro} value={`${item.codParceiro}`}>
        {item.codParceiro + ' - ' + item.nomeParceiro}
      </Option>
    ))
  );
  const localStorageItensPersist =
    localStorageActive === true
      ? localStorage.getItem(`codTransportadora${window.location.pathname}`) || ''
      : '';

  return (
    <>
      <Form.Item name="codTransportadora" label={<TextFilter>Transportadora</TextFilter>}>
        <Select
          showSearch
          onChange={onChange}
          filterOption={(inputValue, element) =>
            element?.props.children.toString().toLowerCase().includes(inputValue.toLowerCase())
          }
          defaultValue={localStorageItensPersist}
          loading={loading}
          notFoundContent={<Spin style={{ textAlign: "center", width: "100%" }} />}

        >
          {children}
        </Select>
      </Form.Item>
    </>
  );
};

export default SelectTransportadoraParceira;
